import { Placement, ToastLevel, ToastType } from '@philips-emr/tws-constants';
import { ToastService } from '@philips-emr/tws-core/lib/services';
import { ToastProps } from '@philips-emr/tws-core/lib/services/toast-service';

type ToastTypes = 'message' | 'title' | 'timeout' | 'id';

const extraToastOption: Omit<ToastProps, ToastTypes> = {
  dismissible: true,
  placement: Placement.TOP,
  type: ToastType.BANNER,
  showIcon: true,
  highlight: false,
  offset: 70,
};

const bubble: Omit<ToastProps, ToastTypes> = {
  dismissible: true,
  placement: Placement.TOP,
  type: ToastType.BUBBLE,
  showIcon: true,
  highlight: false,
  offset: 70,
};

class ToastServiceProviderAccreditation {

  private static time = 5000;
  private static timeBubble = 2000;
  private static msg = 'pa.warning';

  public static error(message: string, title = this.msg, timeout: number = this.time): void {
    this.showToast(ToastLevel.ERROR, message, title, timeout, bubble);
  }

  public static information(message: string, title = this.msg, timeout: number = this.time, options?: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'>): void {
    this.showToast(ToastLevel.INFORMATION, message, title, timeout, options);
  }

  public static success(message: string, title = this.msg, timeout: number = this.time, options?: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'>): void {
    this.showToast(ToastLevel.SUCCESS, message, title, timeout, options);
  }

  public static warning(message: string, title = this.msg, timeout: number = this.time, options?: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'>): void {
    this.showToast(ToastLevel.WARNING, message, title, timeout, options);
  }

  public static successBubble(message: string, title = this.msg, timeout: number = this.time): void {
    this.showToast(ToastLevel.SUCCESS, message, title, timeout, extraToastOption);
  }
  
  public static informationBubble(message: string, title = this.msg, timeout: number = this.timeBubble): void {
    this.showToast(ToastLevel.INFORMATION, message, title, timeout, bubble);
  }

  private static showToast(level: ToastLevel, message: string, title: string, timeout: number, options?: Omit<ToastProps, 'message' | 'title' | 'timeout' | 'id'>): void {
    const toastOption = { ...extraToastOption, ...options };

    ToastService.open({
      id: 'toast.service-provider-accreditation',
      title,
      message,
      timeout,
      level,
      ...toastOption,
    });
  }

  public static close(): void {
    ToastService.close('toast.service-provider-accreditation');
  }
}

export {
  ToastServiceProviderAccreditation,
};
